import React from 'react';
import { injectIntl } from 'react-intl';
import Modal from 'components/Modal';

import PreviewQuoteToInvoiceForm from 'components/forms/quotes/PreviewQuoteToInvoiceForm';

class QuoteConvertToInvoice extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shown: false,
    };
  }

  onShow = () => {
    this.setState({ shown: true });
  };

  onExit = () => {
    this.setState({ shown: false });
  };

  close = e => {
    e.preventDefault();
    const { close } = this.props;
    close();
  };

  render() {
    const {
      alreadyInModal,
      intl: { messages },
      show,
      quote,
      close,
      onSubmitParent,
    } = this.props;
    const { shown: stateShow } = this.state;

    const content = (
      <PreviewQuoteToInvoiceForm
        show={(!alreadyInModal && show) || (alreadyInModal && stateShow)}
        quote={quote}
        onSubmitParent={onSubmitParent}
      />
    );

    return alreadyInModal ? (
      <div className={show ? '' : 'hide'}>
        <div className="bg-master-lightest padding-10 p-l-20 cursor" onClick={this.close}>
          <i className="m-r-10 fa fa-angle-left" /> {messages.back}
        </div>

        {content}
      </div>
    ) : (
      <Modal show={show} onHide={close} bsSize="lg" className="full-width" onExit={this.onExit} onShow={this.onShow}>
        <Modal.Header closeButton>
          <Modal.Title>{messages.convert_quote_to_invoice}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{content}</Modal.Body>
      </Modal>
    );
  }
}
QuoteConvertToInvoice.defaultProps = {
  alreadyInModal: false,
};

export default injectIntl(QuoteConvertToInvoice);
